import { useContext } from "react";
import { SSEContext } from "../SSEContext";

export const useSSE = () => {
  const context = useContext(SSEContext);
  if (!context) {
    throw new Error("useSSE doit être utilisé à l'intérieur d'un SSEProvider");
  }
  return context;
};
